import { convertValueByType } from '../../object-to-microdata.js';
import { arrayMax } from '../../util/array.js';
import { CrdtAlgorithmStandard } from '../interfaces/CrdtAlgorithmStandard.js';
export class CrdtRegister extends CrdtAlgorithmStandard {
    id = 'Register';
    initialDiff(obj, valueType) {
        function toString(value) {
            return convertValueByType(value, 'INITIALDIFF.CrdtRegister', valueType, true);
        }
        return [
            {
                op: 'set',
                value: toString(obj)
            }
        ];
    }
    diff(obj1, obj2, valueType) {
        function toString(value) {
            return convertValueByType(value, 'DIFF.CrdtRegister', valueType, true);
        }
        const obj1Str = toString(obj1);
        const obj2Str = toString(obj2);
        return obj1Str === obj2Str
            ? []
            : [
                {
                    op: 'set',
                    value: obj2Str
                }
            ];
    }
    merge(tree) {
        if (tree.firstMergeNode.dataType !== undefined) {
            throw new Error('Child has no dataType member');
        }
        const hasSetTransformation = (node) => {
            return node.predecessorDiff.filter(t => t.op === 'set').length > 0;
        };
        const firstSetNode = tree.findMaximumPredecessingTopLevelNode(tree.firstMergeNode, hasSetTransformation, CrdtRegister.compareFn);
        const secondSetNode = tree.findMaximumPredecessingTopLevelNode(tree.secondMergeNode, hasSetTransformation, CrdtRegister.compareFn);
        // Just use the value of the node with the highest priority
        const winningNode = arrayMax([firstSetNode, secondSetNode], CrdtRegister.compareFn);
        // Not sure if this case can even happen, because if winningNode is undefined, no
        // value was set, so the only predecessor would be empty => no merge would happen
        if (winningNode === undefined) {
            if (tree.commonHistoryNode.type === 'empty') {
                throw new Error('CrdtRegister.merge: winning node is undefined and common history empty.');
            }
            return tree.commonHistoryNode.data;
        }
        if (winningNode.data === undefined) {
            throw new Error('CrdtRegister.merge: winning node has no data.');
        }
        return winningNode.data;
    }
    static compareFn(node1, node2) {
        // Handle undefined case
        if (node1 === undefined && node2 === undefined) {
            return 0;
        }
        else if (node1 === undefined) {
            return -1;
        }
        else if (node2 === undefined) {
            return 1;
        }
        // Check if transition exists
        const node1HasOp = node1.predecessorDiff.length > 0;
        const node2HasOp = node2.predecessorDiff.length > 0;
        if (node1HasOp !== node2HasOp) {
            if (node1HasOp) {
                return 1;
            }
            else {
                return -1;
            }
        }
        // Check creation time
        if (node1.obj.creationTime > node2.obj.creationTime) {
            return 1;
        }
        else if (node1.obj.creationTime < node2.obj.creationTime) {
            return -1;
        }
        // Last resort compare data pointed to
        if (node1.hash > node2.hash) {
            return 1;
        }
        else if (node1.hash < node2.hash) {
            return -1;
        }
        return 0;
    }
}
//# sourceMappingURL=CrdtRegister.js.map